// extracted by mini-css-extract-plugin
export var equalColumn = "_dk-0";